import moment, { Moment } from "moment";

import Visitable from "../../../shared/interfaces/visitable.ts";
import { TypedAlias } from "../../../../laravel";
import TagModel, { Tag } from "./TagModel.ts";

export interface Alias extends Omit<TypedAlias, "tags">, Visitable<Alias> {
    tags: Tag[],
    setVisit(newVisit: (alias: Alias) => void): Alias,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- query bag mirrors the untyped router visit payload
    setTagVisit(callback: (tag: Tag, query?: Record<string, any>) => void): Alias,
    setTags(tags: Array<string>): Alias,
    createdAt(): Moment,
    expiresAt(): Moment
}

export function AliasFactory(data: TypedAlias): Alias {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- query bag mirrors the untyped router visit payload
    let visitOverride: ((model: Alias, query?: Record<string, any>) => void) | null = null;

    const that = {
        ...data,
        tags: (data.tags || []).map((tagName: string) => TagModel(tagName)),

        createdAt(): Moment {
            return moment(that.created_at);
        },

        expiresAt(): Moment {
            return moment(that.expires_at);
        },

        /**
         * Redirect the browser to the show page for this team
         * @param query optional query string params to add
         */
        visit: function (query = {}) {
            if (visitOverride) {
                visitOverride(that, query);
            }
        },

        /**
         * Allows you to set the function that is called when you call the visit method
         */
        setVisit(callback = (alias: Alias, query = {}) => { }): Alias {
            visitOverride = callback;
            return that;
        },

        /**
         * Sets the visit callback for all tags on this alias
         */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any -- query bag mirrors the untyped router visit payload
        setTagVisit(callback: (tag: Tag, query?: Record<string, any>) => void): Alias {
            that.tags.forEach((tag: Tag) => tag.setVisit(callback));
            return that;
        },

        /**
         * Allows you to change the tags stored on this model
         * @param tags
         */
        setTags(tags: Array<string>): Alias {
            that.tags = tags.map((tagName: string) => TagModel(tagName));
            return that;
        }
    };

    return that;
}
